import {$Toast} from "@api";
import {useEffect, useRef} from "react";
import {SafeAny, ToastProps} from "@models";
import {overlayEmitter} from "@api";

export const Toast = (prop: ToastProps) => {
  const toast = useRef<SafeAny>(null);
  const isRendered = useRef(false);

  useEffect(() => {
    if (isRendered.current) {
      return
    }
    isRendered.current = true;
    overlayEmitter.on('toast', options => {
      toast.current?.show(options);
    });
  }, []);

  return (
      <$Toast {...prop} ref={toast}/>
  );
};
